/*
 * @Author: bbqin
 * @Date: 2022-09-07 15:42:27
 * @LastEditTime: 2022-09-09 15:08:41
 * @LastEditors: bbqin
 * @Description: 如果我没写，可能我忘了。如果我忘了，可能我没看。如果我没看，可能我没写。
 * @FilePath: \Platform_Front\src\platform\FastExtend\ExtendStyle.js
 * (混沌)足够多的方案才能接近真实的结果。
 */
// 扩展platform样式表
import { getGlobalStorage, setGlobalStorage, syncAjax, addDataSign, getCookie, getTopWindow } from '@platform/api';

const ExtendStyle = () => {
    getExtendStyleSwitch();
    if (getGlobalStorage('localStorage', '_ncc_extend_style_') !== '1') return;

    let domHead = document.getElementsByTagName('HEAD').item(0);
    // 插入新style
    let style = document.createElement('link');
    // 这里暂时没有考虑hash的情况 TODO
    style.href = `../../../../NCCExtend/extend_platform/index.css`;
    style.rel = 'stylesheet';
    style.type = 'text/css';
    style.onerror = function (e) {
        console.log('未能platform扩展样式表', 'NCCExtend/extend_platform/index.css');
    };

    domHead.appendChild(style);
};

export default ExtendStyle;

function getExtendStyleSwitch() {
    if (NODE_ENV === 'development') {
        return;
    }
    let NCC_SYS_Switch = JSON.parse(localStorage.getItem('NCC_SYS_Switch'));
    if (NCC_SYS_Switch === null) {
        let cookiets = (getTopWindow() && getTopWindow().cookiets) || getCookie('cookiets') || Date.now(); //双cookie验证 liuxis
        let reqData = { 
            sysParamJson: { 
                busiaction: '查询系统开关',
                pagecs: cookiets,
                ts: new Date().getTime(), 
            }, 
        };
        // 做一次 数据转型
        cookiets = isNaN(cookiets) ? cookiets : Number(cookiets);
        let headers = { 'Content-Type': 'application/json;charset=UTF-8', cookiets };
        reqData = JSON.stringify(addDataSign(reqData, '', { allin: true, headers: headers }));
        syncAjax({
            type: 'post',
            url: '/nccloud/platform/total/switch.do',
            async: false,
            data: reqData,
            headers: headers,
            success: res => {
                if (res) {
                    res = JSON.parse(res);
                    if (res.data) {
                        let NCC_SYS_Switch = res.data || {};
                        let localStorageSwitch = localStorage.getItem('storeCipher');
                        //缓存是否加密开关变化了
                        if(localStorageSwitch != NCC_SYS_Switch.localStorage){
                            //localStorage加密开关与上次不一致，则清空所有localStorage内容
                            localStorage.clear();
                        }
                        localStorage.setItem('NCC_SYS_Switch', JSON.stringify(NCC_SYS_Switch));
                        localStorage.setItem('storeCipher', NCC_SYS_Switch.localStorage ? '1' : '0');
                        setGlobalStorage('localStorage', '_ncc_automated_', NCC_SYS_Switch.automated_test ? '1' : '0');
                        setGlobalStorage('localStorage', '_ncc_extend_style_', NCC_SYS_Switch.extendstyle ? '1' : '0');
                    }
                }
            }
        });
    }

}



